import moment from "moment";
import countryList from "country-list";
import { toast } from "react-toastify";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import SeatModal from "../SelectSeat/SeatModal";
import ButtonPrimary from "../../Button/ButtonPrimary";
import convertNumbThousand from "../../../utils/convertNumbThousand";
import apiBooking from "../../../redux2/booking/apiBooking";
import {
  getBookingById,
  resetBooking,
} from "../../../redux2/booking/bookingSlice";
import { getMe, getMyCompany } from "../../../redux2/user/userSlice";
import customTime from "../../../utils/customTime";
import { getMyEnterprise } from "../../../redux2/enterprise/enterpriseSlice";
import {
  USER_ROLE_AGENT,
  USER_ROLE_EMPLOYEE,
  USER_ROLE_ENTERPRISE,
  USER_ROLE_MEMBER,
  USER_ROLE_SUPERAGENT,
  WALLET_MINIMUM_AMOUNT,
} from "../../../common/constants";

import { confirmAlert } from "react-confirm-alert";
import {
  cancelDuplicateBooking,
  retrieveTicket,
} from "../../../services/flight";
import { getMyCorporate } from "../../../redux2/corporate/corporateSlice";
import PassengerForm from "../../FlightBookingSteps/components/PassengerForm";
import PassportExtractionModal from "../../FlightBookingSteps/PassportExtractionModal";
import { currencyType, getCarrierLogo } from "../../../utils/flightInfo";
import NcImage from "../../NcImage/NcImage";
import Loading from "../../Loading";
import { AmadeusBookingReq } from "../Services/AirRequest.amadeus";
import { AmadeusAirBooking } from "../Services/AmadeusApi";

const ALPHA3_TO_ALPHA2 = {
  ETH: "ET",
  USA: "US",
  GBR: "GB",
  CAN: "CA",
  DEU: "DE",
  FRA: "FR",
  IND: "IN",
  KEN: "KE",
  NGA: "NG",
  ZAF: "ZA",
  EGY: "EG",
  SAU: "SA",
  ARE: "AE",
  CHN: "CN",
  JPN: "JP",
  AUS: "AU",
  BRA: "BR",
  RUS: "RU",
};

const FlightBookingAmadeus = ({ className = "" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const query = new URLSearchParams(location.search);
  const adults = query.get("adults");
  const children = query.get("children");
  const infants = query.get("infants");
  const labors = query.get("labors");
  const tripType = query.get("tripType");
  const isLocal = query.get("isLocal");
  const destination = query.get("destination");
  const passengerTypeState = query.get("passengerTypeState");
  const _id = query.get("_id");

  let totalPassengers = 0;
  if (adults) {
    totalPassengers += parseInt(parseInt(adults));
  }
  if (labors) {
    totalPassengers += parseInt(labors);
  }
  if (children) {
    totalPassengers += parseInt(children);
  }
  if (infants) {
    totalPassengers += parseInt(infants);
  }

  const {
    offer,
    charges,
    queryURL,
    isRoundTrip,
    currency,
    rateDifference,
    amaClientRef,
  } = location.state;

  const { booking, isLoading: bookingLoading } = useSelector(
    (state) => state.booking,
  );
  const { user: authUser } = useSelector((state) => state.auth);
  const { company, isLoading, user } = useSelector((state) => state.user);
  const { enterprise } = useSelector((state) => state.enterprise);
  const { corporate, isLoading: corpLoading } = useSelector(
    (state) => state.corporate,
  );

  const [seatModal, setSeatModal] = useState(false);
  const [seatIndex, setSeatIndex] = useState(0);
  const [reservedSeats, setReservedSeats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [warning, setWarning] = useState("");
  const [data, setData] = useState([]);
  const [commission, setCommission] = useState(0);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [bookingId, setBookingId] = useState("");

  const [formData, setFormData] = useState([
    {
      FirstName: "",
      MiddleName: "",
      LastName: "",
      Email: "",
      phone: "",
      Location: "ETH",
      Nationality: "",
      AreaCode: "251",
      CountryCode: "251",
      DOB: "",
      Gender: "",
      Prefix: "",
      OriginId: "",
      ResidentId: "",
      // address
      AddressName: "",
      Street: "",
      City: "",
      State: "",
      PostalCode: "",
      Country: "",
    },
  ]);

  const [passportData, setPassportData] = useState([
    {
      issueDate: "",
      expiryDate: "",
      issueCountry: "",
      passportNumber: "",
      SupplierCode: "",
      CardNumber: "",
      DocumentType: "P",
      DocumentNumber: "",
      ResidentCountry: "ET",
      ProviderCountry: "ET",
      DateOfBirth: "10OCT19",
      passport: "",
      idCard: "",
      certificate: "",
      other: "",
      ssr: [],
      // visa: "",
    },
  ]);
  const [isExtracting, setIsExtracting] = useState(false);
  const [extractionModalData, setExtractionModalData] = useState(null);
  const [extractionPassengerIndex, setExtractionPassengerIndex] = useState(0);

  useEffect(() => {
    if (_id) {
      dispatch(getBookingById(_id));
    }
  }, [dispatch, _id]);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch, navigate, totalPassengers]);

  useEffect(() => {
    user?.role === USER_ROLE_ENTERPRISE
      ? dispatch(getMyEnterprise())
      : dispatch(getMyCompany());
  }, [dispatch, user?.role]);

  useEffect(() => {
    dispatch(getMyCorporate());
  }, [dispatch]);

  function confirmCancelBooking() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="text-center w-[500px] p-10 bg-white shadow-lg text-black">
            <h1 className="p-2 text-2xl font-bold text-red-500">
              Do you want to cancel the previous booking?
            </h1>
            <p className="text-lg">
              Are you sure you want to cancel the booking?
            </p>
            <button
              onClick={onClose}
              className="w-40 border-1 cursor-pointer text-black text-lg m-2.5 p-2.5 border-black"
            >
              No
            </button>
            <button
              onClick={async () => {
                onClose();
                const data = {
                  bookingId: error?.data?.bookingId,
                  PNR: error?.data?.flight?.retrievalPnr,
                };

                const resRetrieve = await retrieveTicket(
                  error?.data?.flight?.retrievalPnr,
                  setLoading,
                );

                if (!resRetrieve?.UniversalRecordRetrieveRsp?.UniversalRecord) {
                  setError("Network Error, Please try again");
                  setLoading(false);
                  return;
                }

                const docs =
                  resRetrieve?.UniversalRecordRetrieveRsp?.UniversalRecord
                    ?.AirReservation?.DocumentInfo;

                const ticketInfo = Array.isArray(docs?.TicketInfo)
                  ? docs?.TicketInfo
                  : [docs?.TicketInfo];

                if (ticketInfo[0]?._attributes?.TicketingAgentSignOn) {
                  toast.error("This ticket is already issued/Exchanged.");
                  return;
                }
                const response = await cancelDuplicateBooking(
                  data,
                  setLoading,
                  setError,
                );

                if (response?.Fault) {
                  toast.error(response?.Fault?.faultstring?._text);
                }

                if (response?.UniversalRecordCancelRsp) {
                  toast.success("Booking cancelled successfully");
                }
              }}
              disabled={loading}
              className="w-40 border-1 cursor-pointer text-red-500 text-lg m-2.5 p-2.5 border-red-500 font-bold"
            >
              {loading ? "Cancelling..." : "Yes, Cancel it!"}
            </button>
          </div>
        );
      },
    });
  }

  const isCompanyMatch = String(error?.data?.company) === String(company?._id);

  useEffect(() => {
    if (error) {
      toast.error(error?.message || error);
      if (
        error?.data &&
        error?.data?.state &&
        isCompanyMatch &&
        error?.data?.status === "pending"
      ) {
        confirmCancelBooking();
      }
      setError("");
    }
    // if password expired date is less than 6 months show error
    passportData.forEach((passport) => {
      if (passport.expiryDate) {
        let expiryDate = moment(passport.expiryDate);
        let today = moment();
        let diff = expiryDate.diff(today, "months");
        if (diff < 6) {
          setWarning("Your passport is about to expire");
        } else {
          setWarning("");
        }
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, dispatch, passportData]);

  useEffect(() => {
    // if (booking?.data?._id) {
    if (data?.AirReservation && !error) {
      let airReservation = data?.AirReservation;
      let travelers = data?.BookingTraveler;
      let retrievalPnr = data?._attributes?.LocatorCode;
      let reservation = data?.ProviderReservationInfo;
      toast.warning("Reservation Successful");
      navigate(`/checkout/${bookingId}?${queryURL}`, {
        state: {
          charges,
          queryURL,
          travelers,
          systemFee: getSystemFee(),
          retrievalPnr,
          reservation,
          serviceCharge,
          airReservation,
          currency,
          rateDifference,
        },
      });
    }
    dispatch(resetBooking());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.AirReservation, error]);

  useEffect(() => {
    if (booking?.passengers) {
      setFormData([]);
      setPassportData([]);
      Array(totalPassengers)
        .fill()
        .map((_, index) => {
          setFormData((prev) => {
            return [
              ...prev,
              {
                Prefix: booking?.passengers[index]?.title,
                FirstName: booking?.passengers[index]?.firstName,
                MiddleName: booking?.passengers[index]?.middleName,
                LastName: booking?.passengers[index]?.lastName,
                Email: booking?.passengers[index]?.email,
                phone: +booking?.passengers[index]?.phoneNumber
                  ?.toString()
                  ?.slice(3),
                Location: booking?.passengers[index]?.location,
                Nationality: booking?.passengers[index]?.nationality,
                DOB: booking?.passengers[index]?.dob?.split("T")[0],
                Gender:
                  booking?.passengers[index]?.gender === "Male" ? "M" : "F",
              },
            ];
          });
          setPassportData((prev) => {
            return [
              ...prev,
              {
                DocumentNumber: booking?.passengers[index]?.passportNumber,
                expiryDate:
                  booking?.passengers[index]?.passportExpiry?.split("T")[0],
              },
            ];
          });
        });
    }
  }, [booking?.passengers, totalPassengers]);

  const getCountryNameFromCode = useCallback((code) => {
    if (!code) return "";
    const alpha2 = ALPHA3_TO_ALPHA2[code?.toUpperCase()] || code;
    return countryList.getName(alpha2) || code;
  }, []);

  const applyExtractedData = useCallback(
    (data, passengerIndex) => {
      const extracted = data?.documentNumber || data?.firstName;
      if (!extracted) return;

      setFormData((prev) => {
        const next = [...prev];
        next[passengerIndex] = {
          ...next[passengerIndex],
          Prefix: data.title || next[passengerIndex].Prefix,
          FirstName: data.firstName || next[passengerIndex].FirstName,
          MiddleName: data.middleName ?? next[passengerIndex].MiddleName,
          LastName: data.lastName || next[passengerIndex].LastName,
          DOB: data.birthDate || next[passengerIndex].DOB,
          Gender:
            data.sex === "M" || data.sex === "F"
              ? data.sex
              : next[passengerIndex].Gender,
          Nationality: data.nationality
            ? getCountryNameFromCode(data.nationality) ||
              next[passengerIndex].Nationality
            : next[passengerIndex].Nationality,
          ...(data.email !== undefined && { Email: data.email }),
          ...(data.phone !== undefined && { phone: data.phone }),
        };
        return next;
      });

      setPassportData((prev) => {
        const next = [...prev];
        if (!next[passengerIndex]) {
          next[passengerIndex] = {
            issueDate: "",
            expiryDate: "",
            issueCountry: "",
            passportNumber: "",
            SupplierCode: "",
            CardNumber: "",
            DocumentType: "P",
            DocumentNumber: "",
            ResidentCountry: "ET",
            ProviderCountry: "ET",
            DateOfBirth: "10OCT19",
            passport: "",
            idCard: "",
            certificate: "",
            other: "",
            ssr: [],
          };
        }
        next[passengerIndex] = {
          ...next[passengerIndex],
          DocumentNumber:
            data.documentNumber || next[passengerIndex].DocumentNumber,
          expiryDate: data.expirationDate || next[passengerIndex].expiryDate,
          issueCountry: data.issuingState || next[passengerIndex].issueCountry,
        };
        return next;
      });

      toast.success("Passenger details filled from passport");
    },
    [getCountryNameFromCode],
  );

  const onChange = (e, index) => {
    const { name, value } = e.target;
    const newFormData = [...formData];
    newFormData[index] = {
      ...newFormData[index],
      [name]: value,
    };
    setFormData(newFormData);

    // setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSSRChange = (e, index, i) => {
    const { value } = e.target;
    const newPassportData = [...passportData];

    if (!newPassportData[index]) {
      newPassportData[index] = {
        issueDate: "",
        expiryDate: "",
        issueCountry: "",
        ssr: [],
      };
    }
    if (!newPassportData[index].ssr) {
      newPassportData[index].ssr = [];
    }
    newPassportData[index].ssr[i] = value;
    setPassportData(newPassportData);
  };

  async function handleAcceptedFiles(e, index) {
    const { name, files } = e.target;
    if (files.length > 3) {
      toast.error("You can only upload 3 images");
      return;
    }
    if (files[0].size > 5 * 1024 * 1024) {
      toast.error("Image size should be less than 5MB");
      return;
    }
    const file = files[0];
    const newPassportData = [...passportData];
    newPassportData[index] = {
      ...newPassportData[index],
      [name]: file,
    };
    setPassportData(newPassportData);

    const isPassportOrIdCard = name === "passport" || name === "idCard";
    const isImage = file?.type?.startsWith("image/");
    if (isPassportOrIdCard && isImage) {
      setIsExtracting(true);
      try {
        const result = await apiBooking.extractPassport(file);
        const data = result?.data ?? result;
        const hasValidData =
          data &&
          (data.documentNumber || data.firstName) &&
          data.valid !== false;
        if (hasValidData) {
          setExtractionModalData(data);
          setExtractionPassengerIndex(index);
        } else if (result?.error) {
          toast.error(result.error);
        }
      } catch {
        toast.error("Failed to extract passport data");
      } finally {
        setIsExtracting(false);
      }
    }
  }

  const onPassportChange = (e, index) => {
    const { name, value } = e.target;
    const newPassportData = [...passportData];
    newPassportData[index] = {
      ...newPassportData[index],
      [name]: value,
    };
    setPassportData(newPassportData);
    // setPassportData({ ...passportData, [e.target.name]: e.target.value });
  };

  function getSystemFee() {
    return user?.role === USER_ROLE_SUPERAGENT ||
      user?.role === USER_ROLE_EMPLOYEE
      ? 0.2 * serviceCharge
      : charges * 0.2;
    // currencyType(currency) === "USD"
    // ? corporate?.exchangeRate * charges * 0.2
    // : charges * 0.2;
  }

  function getServiceCharge() {
    // if (currencyType(currency) === "USD") {
    //   return charges > 0
    //     ? charges * corporate?.exchangeRate
    //     : serviceCharge * corporate?.exchangeRate;
    // } else {
    //   return charges > 0 ? charges : serviceCharge;
    // }
    return charges > 0 ? charges : serviceCharge;
  }

  function expandPassengers() {
    const result = [];

    offer?.pricing?.passengers.forEach((item) => {
      item.travelerRefNumbers.forEach((ref) => {
        result.push({
          passengerType: {
            ...item.passengerType,
            quantity: 1,
          },
          travelerRefNumbers: [ref],
        });
      });
    });

    return result;
  }

  const onSubmit = async (e) => {
    e.preventDefault();

    if (
      authUser?.role === USER_ROLE_AGENT ||
      authUser?.role === USER_ROLE_MEMBER
    ) {
      if (!company) {
        toast.error("Please Try Again");
        dispatch(getMyCompany());
        return;
      }
    }

    // if (
    //   isLocal === "true" &&
    //   (user?.role === USER_ROLE_MEMBER || user?.role === USER_ROLE_AGENT)
    // ) {
    //   let hasPassportOrIdCard = false;
    //   passportData.forEach((data) => {
    //     if (data?.passport !== "" || data?.idCard !== "") {
    //       hasPassportOrIdCard = true;
    //     }
    //   });
    //   if (!hasPassportOrIdCard) {
    //     toast.error("Please upload passport or id card");
    //     return;
    //   }
    // }

    if (
      enterprise &&
      enterprise?.method === "prePaid" &&
      enterprise?.wallet <
        (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) + parseFloat(totalPrice())
    ) {
      toast.error(
        "Insufficient balance in your wallet. Please deposit money to continue.",
        // "Insufficient Balance. Balance is less than 20,000 birr. Please deposit to your wallet"
      );
      return;
    }

    if (
      user?.role === USER_ROLE_EMPLOYEE &&
      user?.dailyBookingLimit < parseFloat(totalPrice() + user?.dailyBooking)
    ) {
      toast.error("You have reached your daily booking limit.");
      return;
    }

    if (
      (user?.role === USER_ROLE_SUPERAGENT ||
        user?.role === USER_ROLE_EMPLOYEE) &&
      serviceCharge < 1
    ) {
      toast.error("Service Charge must be greater than 0");
      return;
    } else if (
      (user?.role === USER_ROLE_AGENT || user?.role === USER_ROLE_MEMBER) &&
      commission < 1
    ) {
      toast.error("Agent Fee must be greater than 0");
      return;
    }

    // if (
    //   isLocal === "true" &&
    //   formData.length === 1 &&
    //   FlightKey instanceof Object
    // ) {
    //   bookingData2.SpecificSeatAssignment.push({
    //     PassengerKey: bookingRef?.[0]?.BookingTravelerRef,
    //     SegmentRef: FlightKey?._attributes?.Key,
    //     SeatId: reservedSeats?.[0]?.[0]?.[0]?._attributes?.SeatCode,
    //   });
    // }

    const bookingData = {
      amaClientRef: amaClientRef,
      flightOffers: offer,
      travelers: [],
    };

    for (let passenger in formData) {
      bookingData.travelers.push({
        type:
          getTravelerType(offer?.travelerPricings?.[passenger]?.travelerType) ||
          "ADT",
        title: formData[passenger].Prefix?.toUpperCase(),
        firstName: formData[passenger].FirstName,
        middleName: formData[passenger].MiddleName,
        lastName: formData[passenger].LastName,
        email: formData[passenger].Email,
        telephone: {
          areaCode: "251",
          countryCode: "251",
          number: formData[passenger].phone,
        },
        passport: {
          number: passportData[passenger]?.DocumentNumber,
          issueCountry: passportData[passenger]?.issueCountry || "ET",
          expiryDate: passportData[passenger]?.expiryDate,
        },
        dob: formData[passenger].DOB,
        gender: formData[passenger].Gender === "F" ? "Female" : "Male",
        nationality: formData[passenger].Nationality || "Ethiopia",
        refNumber: expandPassengers()?.[passenger]?.travelerRefNumbers[0],
      });
    }

    let files = [];
    for (let i = 0; i < passportData.length; i++) {
      if (passportData[i]?.passport) {
        files.push(passportData[i]?.passport);
      }
      if (passportData[i]?.idCard) {
        files.push(passportData[i]?.idCard);
      }

      if (passportData[i]?.certificate) {
        files.push(passportData[i]?.certificate);
      }

      if (passportData[i]?.other) {
        files.push(passportData[i]?.other);
      }
      // if (passportData[i]?.visa) {
      //   files.push(passportData[i]?.visa);
      // }
    }

    const data = {
      bookingData: AmadeusBookingReq(bookingData, amaClientRef),
      files: files,
      OtherInfo: {
        ServiceCharge: getServiceCharge(),
        USDServiceCharge: charges > 0 ? +charges : +serviceCharge,
        Commission: commission,
        SystemFee: getSystemFee(),
        TripType: tripType,
        isRoundTrip: isRoundTrip || false,
        Destination: destination,
        Origin: offer?.flights?.[0]?.departureAirport?.code,
        company: company?._id,
        rateDifference,
        currency: "ETB",
        // currency: price?.pricing?.totals?.totalFare?.currency,
        user: {
          id: user?._id || authUser?._id,
          role: user?.role || authUser?.role,
        },
      },
    };

    const bookingFormData = new FormData();

    bookingFormData.append("bookingData", JSON.stringify(data));
    for (let i = 0; i < files.length; i++) {
      bookingFormData.append("files", files[i]);
    }

    const response = await AmadeusAirBooking(bookingFormData, setLoading);
    if (response?.error) {
      setError(response?.error);
      setLoading(false);
      return;
    }

    // const response = {
    //   warnings: [
    //     {
    //       status: 200,
    //       code: 0,
    //       title: "LastTicketingDateWarning",
    //       detail:
    //         "The fare booked doesn't correspond to the requested LastTicketingDate",
    //     },
    //   ],
    //   data: {
    //     type: "flight-order",
    //     id: "eJzTd9ePCvZwNw8EAAugAmo",
    //     associatedRecords: [
    //       {
    //         reference: "ZSHG7Q",
    //         creationDate: "2026-01-27T04:52:00.000",
    //         originSystemCode: "GDS",
    //         flightOfferId: "1",
    //       },
    //     ],
    //     flightOffers: [
    //       {
    //         type: "flight-offer",
    //         id: "1",
    //         source: "GDS",
    //         nonHomogeneous: false,
    //         lastTicketingDate: "2026-01-28",
    //         itineraries: [
    //           {
    //             segments: [
    //               {
    //                 departure: {
    //                   iataCode: "ADD",
    //                   terminal: "1",
    //                   at: "2026-02-01T07:45:00",
    //                 },
    //                 arrival: {
    //                   iataCode: "AWA",
    //                   at: "2026-02-01T08:45:00",
    //                 },
    //                 carrierCode: "ET",
    //                 number: "155",
    //                 aircraft: {
    //                   code: "DH8",
    //                 },
    //                 duration: "PT1H",
    //                 id: "1",
    //                 numberOfStops: 0,
    //               },
    //             ],
    //           },
    //         ],
    //         price: {
    //           currency: "ETB",
    //           total: "16122.00",
    //           base: "11271.00",
    //           fees: [
    //             {
    //               amount: "0.00",
    //               type: "TICKETING",
    //             },
    //             {
    //               amount: "0.00",
    //               type: "SUPPLIER",
    //             },
    //             {
    //               amount: "0.00",
    //               type: "FORM_OF_PAYMENT",
    //             },
    //           ],
    //           grandTotal: "16122.00",
    //           billingCurrency: "ETB",
    //         },
    //         pricingOptions: {
    //           fareType: ["PUBLISHED"],
    //           includedCheckedBagsOnly: true,
    //         },
    //         validatingAirlineCodes: ["ET"],
    //         travelerPricings: [
    //           {
    //             travelerId: "1",
    //             fareOption: "STANDARD",
    //             travelerType: "ADULT",
    //             price: {
    //               currency: "ETB",
    //               total: "16122.00",
    //               base: "11271.00",
    //               taxes: [
    //                 {
    //                   amount: "5.00",
    //                   code: "ET",
    //                 },
    //                 {
    //                   amount: "774.00",
    //                   code: "IH",
    //                 },
    //                 {
    //                   amount: "30.00",
    //                   code: "L3",
    //                 },
    //                 {
    //                   amount: "176.00",
    //                   code: "YQ",
    //                 },
    //                 {
    //                   amount: "3866.00",
    //                   code: "YR",
    //                 },
    //               ],
    //             },
    //             fareDetailsBySegment: [
    //               {
    //                 segmentId: "1",
    //                 cabin: "ECONOMY",
    //                 fareBasis: "GET1",
    //                 class: "G",
    //                 includedCheckedBags: {
    //                   weight: 20,
    //                   weightUnit: "KG",
    //                 },
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //     ],
    //     travelers: [
    //       {
    //         id: "1",
    //         dateOfBirth: "2002-06-21",
    //         gender: "FEMALE",
    //         name: {
    //           firstName: "Chloe",
    //           lastName: "Larson",
    //         },
    //         contact: {
    //           purpose: "STANDARD",
    //           phones: [
    //             {
    //               deviceType: "MOBILE",
    //               countryCallingCode: "251",
    //               number: "900000009",
    //             },
    //           ],
    //           emailAddress: "danieltda99@gmail.com",
    //         },
    //       },
    //     ],
    //     formOfPayments: [
    //       {
    //         other: {
    //           method: "CASH",
    //           flightOfferIds: ["1"],
    //         },
    //       },
    //     ],
    //     ticketingAgreement: {
    //       option: "CONFIRM",
    //     },
    //     contacts: [
    //       {
    //         addresseeName: {
    //           firstName: "STERLING TRAVEL AND TOUR",
    //         },
    //         address: {
    //           lines: ["KIRKOS SUBCITY, WEREDA 07, HOUSE# 287/28"],
    //           countryCode: "ET",
    //           cityName: "Addis Ababa",
    //         },
    //         purpose: "INVOICE",
    //         companyName: "STERLING TRAVEL AND TOUR",
    //       },
    //       {
    //         addresseeName: {
    //           firstName: "STERLING TRAVEL AND TOUR",
    //         },
    //         address: {
    //           lines: ["KIRKOS SUBCITY, WEREDA 07, HOUSE# 287/28"],
    //           countryCode: "ET",
    //           cityName: "Addis Ababa",
    //         },
    //         purpose: "STANDARD",
    //         phones: [
    //           {
    //             deviceType: "LANDLINE",
    //             countryCallingCode: "00251",
    //             number: "912737252",
    //           },
    //         ],
    //         companyName: "STERLING TRAVEL AND TOUR",
    //         emailAddress: "natnaelmekonnent@gmail.com",
    //       },
    //     ],
    //   },
    //   dictionaries: {
    //     locations: {
    //       ADD: {
    //         cityCode: "ADD",
    //         countryCode: "ET",
    //       },
    //       AWA: {
    //         cityCode: "AWA",
    //         countryCode: "ET",
    //       },
    //     },
    //   },
    //   amaClientRef: "Sterling-agent-2026-01-27T04:46:33.538Z-7c95b4b5",
    // };

    if (response?.data) {
      navigate(`/amadeus-payment?${query}`, {
        state: {
          reservation: response?.data,
          booking: response?.booking,
          charges,
          serviceCharge,
          systemFee: getSystemFee(),
          commission,
          dictionaries: response?.dictionaries,
          amaClientRef: response?.amaClientRef,
        },
      });
    }

    // const data = new FormData();
    // data.append("bookingData", JSON.stringify(bookingData2));
    // for (let i = 0; i < files.length; i++) {
    //   data.append("files", files[i]);
    // }

    // setLoading(true);
    // axios
    //   .post(API_URL + "flight/booking", data, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   })
    //   .then((res) => {
    //     setBookingId(res.data?.bookingId);
    //     setCreditDue(res.data?.creditDue);
    //     setData(res.data?.AirCreateReservationRsp?.UniversalRecord);
    //     setError(
    //       res.data?.AirCreateReservationRsp?.ResponseMessage?.[1]?._text
    //     );
    //     setError(res.data?.Fault?.faultstring?._text);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     setLoading(false);
    //     setError(err?.response?.data);
    //   });
  };

  if (loading || bookingLoading || isLoading || corpLoading) {
    return <Loading />;
  }

  function totalPrice() {
    const airPrice = parseFloat(offer?.price?.grandTotal);

    let result =
      rateDifference > 1 ? (airPrice * rateDifference).toFixed(2) : airPrice;

    result =
      parseFloat(result) + (charges || 0) + parseFloat(serviceCharge || 0);
    return Number(result.toFixed(2));
  }

  const totalTaxes = offer?.travelerPricings?.reduce((acc, passenger) => {
    return (
      acc +
        passenger.price.taxes?.reduce(
          (taxAcc, fee) => taxAcc + parseFloat(fee.amount),
          0,
        ) || 0
    );
  }, 0);

  const isRequired = (isLocal, user, i) => {
    if (
      user?.role === USER_ROLE_SUPERAGENT ||
      user?.role === USER_ROLE_EMPLOYEE
    ) {
      return false;
    }
    if (
      isLocal === "true" &&
      (passportData[i]?.passport || passportData[i]?.idCard)
    ) {
      return false;
    }
    // if (
    //   isLocal === "false"
    //    &&
    //   (AirSegment.Carrier || AirSegment[0]._attributes.Carrier) === "ET"
    // ) {
    //   return false;
    // }
    return true;
  };

  const getTravelerType = (type) => {
    if (type === "ADULT") {
      return "ADT";
    } else if (type === "CHILD") {
      return "CNN";
    } else if (type === "INFANT") {
      return "INF";
    } else if (type === "LABOUR") {
      return "LBR";
    }
  };

  const renderSidebar = () => {
    return (
      <div className="flex flex-col p-5 space-y-6 w-full shadow sm:rounded-2xl lg:border border-neutral-200 sm:space-y-8 sm:p-6 xl:p-8">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            {/* <div className="overflow-hidden rounded-2xl aspect-w-4 aspect-h-3 sm:aspect-h-4"> */}
            <NcImage src={getCarrierLogo(offer?.validatingAirlineCodes?.[0])} />
            {/* </div> */}
          </div>
          <div className="py-5 space-y-3 sm:px-5">
            <span className="text-lg font-semibold text-neutral-500">
              <h1>{offer?.validatingAirlineCodes?.[0]}</h1>
            </span>
            {offer?.itineraries?.map((itinerary, itineraryIndex) => (
              <div key={itineraryIndex}>
                {itinerary.segments?.map((segment, segmentIndex) => (
                  <div key={segmentIndex}>
                    <span className="text-lg font-semibold text-neutral-500 line-clamp-1">
                      <h1>
                        {segment.departure?.iataCode} -{" "}
                        {segment.arrival?.iataCode}
                      </h1>
                    </span>
                    <span className="block mt-1 text-base font-medium">
                      {moment(segment.departure?.at).format("DD MMM YYYY")} -{" "}
                      {moment(segment.arrival?.at).format("DD MMM YYYY")}
                    </span>
                    <span className="block mt-1 text-base font-medium">
                      {customTime(segment.departure?.at)} -{" "}
                      {customTime(segment.arrival?.at)}
                    </span>
                  </div>
                ))}
              </div>
            ))}
            <div className="flex flex-row justify-between">
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {+adults > 0
                  ? parseInt(adults) + "Adult"
                  : parseInt(labors) + "Labors"}
              </span>
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {children > 0 && children + " Children"}
              </span>
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {infants > 0 && infants + " Infants"}
              </span>
            </div>

            <div className="w-10 border-b border-neutral-200 dark:border-neutral-700"></div>
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Price detail</h3>
          <div>
            {(() => {
              const groupedPricings = {};
              offer?.travelerPricings?.forEach((item) => {
                const key = item.travelerType;
                if (!groupedPricings[key]) {
                  groupedPricings[key] = {
                    count: 0,
                    price: item.price,
                  };
                }
                groupedPricings[key].count += 1;
              });

              return Object.entries(groupedPricings).map(
                ([travelerType, data], index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center py-2 text-neutral-600"
                  >
                    <p>
                      {data.count} * {travelerType}
                    </p>
                    <p className="">
                      {data.price.currency}{" "}
                      {convertNumbThousand(
                        String(parseFloat(data.price.base) * data.count),
                      )}
                    </p>
                  </div>
                ),
              );
            })()}
          </div>

          <div className="flex justify-between">
            <div>
              <span className="text-gray-600">Taxes & Charges:</span>
            </div>
            <span className="font-medium text-main-900">
              {offer?.price?.currency} {convertNumbThousand(totalTaxes)}
            </span>
          </div>

          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            {user?.role === USER_ROLE_SUPERAGENT ||
            user?.role === USER_ROLE_EMPLOYEE ? (
              <span>
                <input
                  type="number"
                  min={1}
                  onWheel={(e) => e.target.blur()}
                  className="p-1 w-20 rounded-md border border-black"
                  value={serviceCharge}
                  onChange={(e) => setServiceCharge(e.target.value)}
                  required
                />{" "}
                {currencyType(currency)}
              </span>
            ) : (
              <span className="text-red-500">
                {charges || 0} {currencyType(currency)}
              </span>
            )}
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Agent Fee</span>
            {user?.role === USER_ROLE_SUPERAGENT ||
            user?.role === USER_ROLE_EMPLOYEE ||
            user?.role === USER_ROLE_ENTERPRISE ? (
              <span>0 birr</span>
            ) : (
              <span className="text-red-500">
                <input
                  type="number"
                  min={1}
                  onWheel={(e) => e.target.blur()}
                  className="p-1 w-20 text-black rounded-md border border-black"
                  value={commission}
                  onChange={(e) => setCommission(e.target.value)}
                  required
                />{" "}
                {currencyType(currency)}
              </span>
            )}
          </div>
          <div className="border-b border-neutral-200"></div>
          <div className="flex justify-between text-xl font-bold text-black">
            <span>Total Price</span>
            <span>
              {convertNumbThousand(
                (totalPrice() + parseFloat(commission || 0)).toFixed(2),
              )}{" "}
              {offer?.price?.currency}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = (index, type) => {
    return (
      <PassengerForm
        index={index}
        type={getTravelerType(type)}
        formData={formData}
        AirSegment={offer?.itineraries?.[0]?.segments}
        passportData={passportData}
        onChange={onChange}
        onPassportChange={onPassportChange}
        handleAcceptedFiles={handleAcceptedFiles}
        onSSRChange={onSSRChange}
        isRequired={isRequired}
        passengerTypeState={passengerTypeState}
        isLocal={isLocal}
        reservedSeats={reservedSeats}
        user={user}
        warning={warning}
        setSeatIndex={setSeatIndex}
        setSeatModal={setSeatModal}
        showAdditionalFields={false}
      />
    );
  };

  return (
    <div
      className={`px-1 py-4 nc-CheckOutPage ${className}`}
      data-nc-id="CheckOutPage"
    >
      <main className="flex flex-col-reverse mt-11 mb-24 lg:mx-24 lg:mb-32 lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10">
          {/* <div className="">{renderMain()}</div> */}
          <form onSubmit={onSubmit}>
            {offer?.travelerPricings?.map((_, index) => {
              return (
                <div className="mb-10">
                  <div className="flex flex-col px-4 mb-2 space-y-8 w-full rounded-md shadow-sm sm:rounded-2xl sm:border border-neutral-200 sm:p-6 xl:p-8">
                    <div>
                      <h3 className="text-2xl font-semibold">
                        Passenger {index + 1} Information (
                        {offer?.travelerPricings?.[index]?.travelerType})
                      </h3>
                      {/* {company &&
                        (company?.wallet < WALLET_MINIMUM_AMOUNT ||
                          company.wallet < parseFloat(totalPrice())) && (
                          <p className="px-3 py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
                            <i className="mr-2 fas fa-exclamation-triangle"></i>
                            Insufficient balance in your wallet. Please deposit
                            money to continue.
                          </p>
                        )} */}
                      {enterprise &&
                        enterprise?.method === "prePaid" &&
                        enterprise?.wallet <
                          (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
                            parseFloat(totalPrice()) && (
                          <p className="px-3 py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
                            <i className="mr-2 fas fa-exclamation-triangle"></i>
                            Insufficient balance in your wallet. Please deposit
                            money to continue.
                          </p>
                        )}
                      {user?.role === USER_ROLE_EMPLOYEE &&
                        user?.dailyBookingLimit <
                          parseFloat(totalPrice() + user?.dailyBooking) && (
                          <p className="px-3 py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
                            <i className="mr-2 fas fa-exclamation-triangle"></i>
                            You have reached your daily booking limit.
                          </p>
                        )}
                      {renderMain(
                        index,
                        offer?.travelerPricings?.[index]?.travelerType,
                      )}
                    </div>
                  </div>

                  <hr className="my-5" />
                </div>
              );
            })}
            <div className="flex justify-end pb-3">
              <ButtonPrimary
                className="block w-72 hover:text-white hover:bg-blue-600 md:w-48"
                type="submit"
              >
                Continue
              </ButtonPrimary>
            </div>
          </form>
        </div>
        <div className="flex-grow mb-10 lg:block">{renderSidebar()}</div>
      </main>
      {/* {seatModal && (
        <SeatModal
          seatModal={seatModal}
          setSeatModal={setSeatModal}
          reservedSeats={reservedSeats}
          setReservedSeats={setReservedSeats}
          airSegment={AirSegment}
          traceId={traceId}
          index={seatIndex}
        />
      )} */}
      <PassportExtractionModal
        isOpen={!!extractionModalData}
        onClose={() => setExtractionModalData(null)}
        data={extractionModalData}
        passengerIndex={extractionPassengerIndex}
        passengerTypeCode={getTravelerType(
          offer?.travelerPricings?.[extractionPassengerIndex]?.travelerType,
        )}
        company={company}
        onAccept={applyExtractedData}
        onReject={() => setExtractionModalData(null)}
      />
      {isExtracting && (
        <div className="flex fixed inset-0 z-50 justify-center items-center bg-black/20">
          <div className="flex gap-3 items-center px-6 py-4 bg-white rounded-xl shadow-lg">
            <div className="w-6 h-6 rounded-full border-2 animate-spin border-primary-500 border-t-transparent" />
            <span className="font-medium text-neutral-700">
              Extracting passport data...
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlightBookingAmadeus;
